import { AppIcons } from '@backstage/core-app-api';
import { devHubDynamicSvgIcon } from '@devxdiscover/devhub-ui';
import { IconComponent } from '@backstage/core-plugin-api';

/**
 * Custom icons for the app. These can be used anywhere an icon name is expected.
 *
 * ```yaml
 *   output:
 *     links:
 *       - title: Installing your Pipeline
 *         icon: concourse  # <-- this is the icon name
 *         url: https://better.delivery.comcast.net/community/practices/ghec/using-concourse-with-github-enterprise-cloud/#fly-cli
 *  ```
 */
export const customIcons: Partial<AppIcons> & { [key: string]: IconComponent } =
  {
    concourse: devHubDynamicSvgIcon('AccountTree'),
    qa: devHubDynamicSvgIcon('QuestionAnswer'),
  };
